import { render, staticRenderFns } from "./body-info.vue?vue&type=template&id=531cd2d6&scoped=true"
import script from "./body-info.vue?vue&type=script&lang=js"
export * from "./body-info.vue?vue&type=script&lang=js"
import style0 from "./body-info.vue?vue&type=style&index=0&id=531cd2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cd2d6",
  null
  
)

export default component.exports